/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {acceptTileUpdate} from '../api'

export const useMutationAcceptTileUpdate = createReactQueryMutationHook('acceptTileUpdate', acceptTileUpdate)
